<template>
  <div class="relative d-flex align-center justify-center">
    <div
      class="resize-box absolute-fill"
      v-bind:class="{
        'as-override': !isPrimary && !isCropping,
        crop: isCropping,
        shadow: isCropping || (indirectEdit && focused)
      }"
    />
    <template v-if="canTransform">
      <div
        v-for="[x, y] in [ [-1, -1], [1, -1], [1, 1], [-1, 1] ]" :key="`${x}${y}`"
        class="btn-wrapper corner"
        v-bind:class="{ crop: isCropping }"
        v-bind:style="{
          left: x < 0 ? - btnOffset + 'px' : undefined,
          right: x > 0 ? - btnOffset + 'px' : undefined,
          top: y < 0 ? - btnOffset + 'px' : undefined,
          bottom: y > 0 ? - btnOffset + 'px' : undefined
        }"
        @mousedown="e => $emit('resize', e)"
        @touchstart="e => $emit('resize', e)"
      >
        <!-- We want the buttons to look small, but still be usable on mobile, so we use the containing div as an invisible background "button" -->
        <v-btn
          v-blur
          class="ma-3"
          style="cursor: inherit;"
          v-bind:style="{ transform: `scale(${1 / scale})` }"
          fab x-small color="red"
          :disabled="disabled"
          @contextmenu.native.stop.prevent
        />
      </div>
      <template v-if="isCropping">
        <div class="absolute-fill d-flex align-end" style="bottom: 0;" @click.capture.stop.prevent>
          <v-slider
            class="crop-rotate-slider"
            style="pointer-events: auto;"
            min="-45" max="45" hide-details color="transparent" track-color="transparent" thumb-label="always"
            thumb-color="deep-orange"
            :thumb-size="44 / scale"
            :step="snap ? 5 : 1"
            :value="blob.crop.r > 45 ? blob.crop.r - 360 : blob.crop.r"
            @input="v => blob.crop.r = v < 0 ? 360 + v : v"
          >
            <template v-slot:thumb-label>
              <v-icon v-bind:style="{ transform: `scale(${1 / scale})` }" color="white" v-html="mdiCropRotate" />
            </template>
          </v-slider>
        </div>
      </template>
      <div
        v-else
        class="btn-wrapper"
        style="bottom: -72px;"
        @mousedown="e => $emit('rotate', e)"
        @touchstart="e => $emit('rotate', e)"
      >
        <v-btn
          v-blur
          class="ma-3"
          style="cursor: inherit;"
          v-bind:style="{ transform: `scale(${1 / scale})` }"
          fab small color="red"
          :disabled="disabled"
        >
          <v-icon color="white" v-html="mdiRotateRight" />
          <span class="btn-tooltip bottom">Drag to rotate</span>
        </v-btn>
      </div>
    </template>
  </div>
</template>


<style scoped>
.resize-box {
  outline: 4px dashed red;
  box-shadow:
    inset 0 0 8px 8px rgba(255, 255, 255, .2),
    0 0 8px 8px rgba(255, 255, 255, .2);
  transition: box-shadow .3s;
}
.resize-box.as-override {
  /* This color matches Vuetify 'blue' (which is probably available as an scss variable somewhere...) */
  outline: 4px dashed #2196F3;
}
.resize-box.crop {
  /* This color matches Vuetify 'deep-orange' (the color we use for the crop controls) */
  outline: 4px dashed #FF5722;
}
.resize-box.shadow {
  /* You could use this to align the outline tightly to the bounds of an IMAGE of VIDEO blob */
  /* outline-offset: -8px; */
  box-shadow:
    inset 0 0 8px 8px rgba(0, 0, 0, .2),
    0 0 8px 8px rgba(0, 0, 0, .2),
    0 0 1280px 1280px rgba(0, 0, 0, .2);
}
.btn-wrapper {
  position: absolute;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  pointer-events: auto;
  cursor: grab;
}
.btn-wrapper.corner {
  z-index: 1;
}
.btn-wrapper:active {
  cursor: grabbing;
  .btn-tooltip {
    display: none;
  }
}
.btn-wrapper > button {
  cursor: inherit;
}
.btn-wrapper.crop > button {
  background-color: #FF5722 !important;
}
</style>

<style>
.crop-rotate-slider .v-slider__thumb-label-container {
  transform: rotate(180deg);
  transform-origin: center 4px;
}

.crop-rotate-slider .v-slider__thumb {
  opacity: 0;
}

.crop-rotate-slider .v-slider__thumb-label {
  cursor: pointer;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
</style>


<script>
import { mdiRotateRight, mdiTextBoxEdit, mdiCropRotate, mdiSelectDrag, mdiCheck } from '@mdi/js';


export default {
  name: 'blob-selection-controls',

  props: [ 'blob', 'canTransform', 'isPrimary', 'mode', 'isCropping', 'snap', 'scale', 'indirectEdit', 'focused' ],

  data() {
    return {
      showDoneBtn: false
    };
  },

  computed: {
    disabled() {
      return this.indirectEdit && (this.blob.type == 'TEXT') && !!this.focused;
    }
  },

  created() {
    Object.assign(this, { btnOffset: 30, mdiRotateRight, mdiTextBoxEdit, mdiCropRotate, mdiSelectDrag, mdiCheck });
  }
}
</script>
